export enum SegmentStatus {
    Draft = 'created',
    Published = 'published',
    Archived = 'archived',
    Scheduled = 'scheduled'
}
